import { render } from "./PendingOrders.vue?vue&type=template&id=734ec466&scoped=true"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"

import "./PendingOrders.vue?vue&type=style&index=0&id=734ec466&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-734ec466"]])

export default __exports__